


export const generalFontSize = 16
export const generalLineHeigth = 24